import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import cx from 'classnames';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { useDeviceType } from '../../../responsive';
import { getStyles } from './styles';
var RadioComponent = /*#__PURE__*/React.forwardRef(function Radio(props, ref) {
  var disabled = props.disabled,
      invalid = props.invalid,
      label = props.label;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  return /*#__PURE__*/React.createElement(ControlInputContainer, _extends({}, props, {
    type: "radio",
    className: cx(styles['radio'], disabled && styles['disabled'], invalid && styles['invalid'], !!label && styles['hasLabel']),
    ref: ref
  }), /*#__PURE__*/React.createElement("span", {
    className: styles['indicator']
  }), label && /*#__PURE__*/React.createElement("span", {
    className: styles['label']
  }, label));
});
/**
 * Компонент простого radio с лейблом
 *
 * На телефоне имеет блочный дизайн и radio справа
 *
 * @export
 * @param {IRadioProps} props
 * @returns
 */

export var Radio = /*#__PURE__*/React.memo(RadioComponent);